import React from 'react';

import {
  DECORATION_STYLES,
  DEFAULT_DECORATION,
} from 'js/utils/sentiment-question';
import ActionSelector from 'js/components/Assessment/Editors/common/components/ActionSelector';

/**
 * Picks the decoration style for a sentiment scale.
 */
export function DecorationSelector({
  decoration = DEFAULT_DECORATION,
  onChange = () => {},
}) {
  return (
    <ActionSelector
      value={decoration}
      options={DECORATION_STYLES}
      onChange={onChange}
    />
  );
}

export default DecorationSelector;
